export default __webpack_public_path__ + "static/media/todolist.0973724f.png";